import { exists as c } from "../runtime.js";
import { AccountBalanceAccountTypeFromJSON as o, AccountBalanceAccountTypeToJSON as n } from "./AccountBalanceAccountType.js";
import { AccountBalanceSourceFromJSON as t, AccountBalanceSourceToJSON as i } from "./AccountBalanceSource.js";
import { CreditVoucherEntryFromJSON as a, CreditVoucherEntryToJSON as d } from "./CreditVoucherEntry.js";
import { CurrencyFromJSON as u, CurrencyToJSON as y } from "./Currency.js";
const A = {
  Creditlimit: "CREDITLIMIT",
  Credit: "CREDIT",
  Debit: "DEBIT",
  Expire: "EXPIRE",
  Auth: "AUTH",
  Void: "VOID",
  Capture: "CAPTURE",
  Cancel: "CANCEL",
  Refund: "REFUND"
};
function B(r) {
  let e = !0;
  return e = e && "accountId" in r, e = e && "accountType" in r, e = e && "entryType" in r, e = e && "amountValue" in r, e = e && "source" in r, e;
}
function f(r) {
  return p(r);
}
function p(r, e) {
  return r == null ? r : {
    accountId: r.accountId,
    orderId: c(r, "orderId") ? r.orderId : void 0,
    voucherId: c(r, "voucherId") ? r.voucherId : void 0,
    accountType: o(r.accountType),
    currency: c(r, "currency") ? u(r.currency) : void 0,
    entryType: r.entryType,
    amountValue: r.amountValue,
    payload: c(r, "payload") ? r.payload : void 0,
    source: t(r.source),
    reason: c(r, "reason") ? r.reason : void 0,
    originator: c(r, "originator") ? r.originator : void 0,
    id: c(r, "id") ? r.id : void 0,
    availableBalance: c(r, "availableBalance") ? r.availableBalance : void 0,
    version: c(r, "version") ? r.version : void 0,
    entries: c(r, "entries") ? r.entries.map(a) : void 0
  };
}
function C(r) {
  if (r !== void 0)
    return r === null ? null : {
      accountId: r.accountId,
      orderId: r.orderId,
      voucherId: r.voucherId,
      accountType: n(r.accountType),
      currency: y(r.currency),
      entryType: r.entryType,
      amountValue: r.amountValue,
      payload: r.payload,
      source: i(r.source),
      reason: r.reason,
      originator: r.originator,
      id: r.id,
      availableBalance: r.availableBalance,
      version: r.version,
      entries: r.entries === void 0 ? void 0 : r.entries.map(d)
    };
}
export {
  A as AccountBalanceEntryEntryTypeEnum,
  f as AccountBalanceEntryFromJSON,
  p as AccountBalanceEntryFromJSONTyped,
  C as AccountBalanceEntryToJSON,
  B as instanceOfAccountBalanceEntry
};
//# sourceMappingURL=AccountBalanceEntry.js.map
